import React from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

interface OptionTemplateAnimatedProps {
  children: React.ReactNode;
  testId?: string;
  className?: string;
}
export const OptionTemplateAnimated = ({
  children,
  testId,
  className,
}: OptionTemplateAnimatedProps) => {
  return (
    <div
      className={concatClassnames(
        "gg-border-b gg-border-dark-blue-100 gg-px-4 gg-pb-6 gg-pt-8 sm:gg-px-7",
        className,
      )}
      data-testid={testId}
    >
      {children}
    </div>
  );
};
